import BaseComponent from "../../baseComponent.js";
import TabList from "./tabList.jsx";
import CurrentTab from "./currentTab.jsx";
import styles from "../../common/dashboard-tab.scss";

export default class ProfileTabs extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: this.props.tabs[0],
      tabs: this.props.tabs
    }
  }

  componentDidMount() {
    this.show();
  }

  onTabChange(tabIndex) {
    let tabs = this.props.tabs.map((tab, index) => {
      tab.activated = tabIndex === index;
      return tab;
    });
    this.setState({
      currentTab: this.props.tabs[tabIndex],
      tabs: tabs
    });

    this.props.onTabChange(tabIndex);
  }

  show() {
    let _this = this;
    setTimeout(function () {
      $(_this.refs.container).css("opacity", 1);
    }, 500);
  }

  render() {
    return (
      <div id="tab-container" className={styles.dashboardTabs}  ref="container">
        <CurrentTab tab={this.state.currentTab}/>
        <TabList tabs={this.state.tabs} onTabChange={this.onTabChange}/>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/profile/tab/profileTabs.jsx